import { ValidationObserver, ValidationProvider } from 'vee-validate';
import Paginate from 'vue-pagination-2'
import JwPagination from 'jw-vue-pagination';
import DatePick from 'vuejs-datepicker';
import MultiSelect from 'vue-multiselect'
import Pdf from 'vue-pdf';


import ChartCard from "./ChartCard.vue";
import StatsCard from "./StatsCard.vue";
import AccountInfo from "./AccountInfo.vue";
import PwdChange from "./PwdChange.vue";
import ProfilEdit from "./ProfilEdit.vue";
import Signature from "./Signature.vue";
import Messages from "./Messages.vue";

import Tab from "./Tab.vue";
import Tabs from "./Tabs.vue";
import Modal from "./Modal.vue";
import Loader from "./Loader.vue";
import Breadcrumb from './Breadcrumb';
import SearchInput from './SearchInput';
import SearchInputAll from './SearchInputAll';

let components = {Tab, Tabs, Modal, Loader, Pdf, ValidationObserver, DatePick, MultiSelect, Paginate, JwPagination, ValidationProvider, Breadcrumb, SearchInput, SearchInputAll};

const gComponent = {
  install(Vue) {
      Object.keys(components).forEach(name =>
          Vue.component(name, components[name]));
  }
};

export default gComponent;
export {
    ChartCard,
    StatsCard,
    PwdChange,
    ProfilEdit,
    AccountInfo,
    Signature,
    Messages,
};